<template>
  <router-view></router-view>
</template>
<script>

export default {
  data() {
    return {
     
    };
  }
};
</script>

<style>
:root {
  --admin-bg: #f4f7fb;
  --admin-surface: rgba(255, 255, 255, 0.94);
  --admin-surface-strong: #ffffff;
  --admin-border: rgba(29, 43, 64, 0.1);
  --admin-border-strong: rgba(29, 43, 64, 0.16);
  --admin-text: #18212f;
  --admin-muted: #718096;
  --admin-primary: #1677ff;
  --admin-primary-deep: #0f5fd5;
  --admin-cyan: #00a896;
  --admin-green: #2f9e44;
  --admin-amber: #d97706;
  --admin-red: #e03131;
  --admin-purple: #7c3aed;
  --admin-radius: 8px;
  --admin-shadow: 0 18px 48px rgba(23, 31, 46, 0.11);
  --admin-shadow-soft: 0 10px 28px rgba(23, 31, 46, 0.08);
  --admin-sidebar: #171511;
  --admin-sidebar-2: #201d18;
}

* {
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
}

body {
  min-width: 1180px;
  overflow: hidden;
  user-select: none;
  color: var(--admin-text);
  background:
    linear-gradient(135deg, rgba(22, 119, 255, 0.08), transparent 34%),
    linear-gradient(315deg, rgba(0, 168, 150, 0.09), transparent 32%),
    var(--admin-bg);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Microsoft YaHei", Arial, sans-serif;
  text-rendering: geometricPrecision;
}

button,
input,
textarea,
select {
  font-family: inherit;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(113, 128, 150, 0.28);
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(113, 128, 150, 0.42);
}

#app .home-main {
  position: relative;
  min-width: 0;
  overflow: hidden;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0)),
    linear-gradient(var(--admin-bg), var(--admin-bg)) !important;
}

#app .home-main::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(24, 33, 47, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(24, 33, 47, 0.035) 1px, transparent 1px);
  background-size: 28px 28px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.75), transparent 76%);
}

#app .home-main > * {
  position: relative;
  z-index: 1;
}

#app .app-admin-page,
#app .app-preview-page,
#app .runtime-log-page,
#app .game-admin-page {
  width: 100% !important;
  height: 100% !important;
  padding: 24px !important;
  overflow: auto !important;
  background: transparent !important;
}

#app .app-admin-card,
#app .app-preview-card,
#app .runtime-log-card,
#app .game-admin-card,
#app .home-main > div > div[style*="box-shadow"] {
  width: 100% !important;
  margin: 0 !important;
  padding: 24px !important;
  border: 1px solid var(--admin-border) !important;
  border-radius: var(--admin-radius) !important;
  background: var(--admin-surface) !important;
  box-shadow: var(--admin-shadow) !important;
  box-sizing: border-box !important;
}

#app .app-admin-card,
#app .runtime-log-card,
#app .game-admin-card {
  min-height: 100% !important;
}

#app .app-preview-card {
  height: 100% !important;
}

#app .home-main > div > div[style*="box-shadow"] {
  width: calc(100% - 48px) !important;
  height: calc(100% - 48px) !important;
  margin: 24px !important;
  overflow: hidden !important;
}

#app .home-main > div > div[style*="box-shadow"] > div {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
}

#app .toolbar,
#app .page-header,
#app .section-head,
#app .history-head,
#app .kline-head,
#app .card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

#app .toolbar-actions,
#app .history-actions,
#app .search-row,
#app .button-row,
#app .form-row,
#app .upload-line {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

#app .page-title,
#app .title,
#app .section-title,
#app .dialog-title {
  color: var(--admin-text) !important;
  font-size: 22px !important;
  line-height: 1.3 !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
}

#app .section-title,
#app .card-header {
  font-size: 17px !important;
}

#app .page-subtitle,
#app .muted,
#app .inline-tip,
#app .status-line {
  color: var(--admin-muted) !important;
  line-height: 1.65;
}

#app .strong,
#app .info-title,
#app .post-title,
#app .user-name {
  color: var(--admin-text);
  font-weight: 700;
}

#app .mono,
#app .detail-pre,
#app .log-json {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
}

#app .el-button {
  min-height: 34px;
  border-radius: var(--admin-radius);
  border-color: var(--admin-border-strong);
  color: #2d3748;
  font-weight: 650;
  letter-spacing: 0;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease,
    background 0.18s ease;
}

#app .el-button:hover {
  transform: translateY(-1px);
  border-color: rgba(22, 119, 255, 0.42);
  color: var(--admin-primary);
  box-shadow: var(--admin-shadow-soft);
}

#app .el-button--primary {
  border-color: transparent;
  color: #fff;
  background: linear-gradient(135deg, var(--admin-primary), #00a896);
  box-shadow: 0 10px 22px rgba(22, 119, 255, 0.22);
}

#app .el-button--primary:hover,
#app .el-button--primary:focus {
  color: #fff;
  border-color: transparent;
  background: linear-gradient(135deg, var(--admin-primary-deep), #008f7d);
}

#app .el-button--danger {
  border-color: transparent;
  color: #fff;
  background: linear-gradient(135deg, #f03e3e, #f76707);
}

#app .el-button--text {
  min-height: auto;
  padding: 0 4px;
  color: var(--admin-primary);
  box-shadow: none;
}

#app .el-button--text:hover {
  transform: none;
  color: var(--admin-primary-deep);
  box-shadow: none;
}

#app .danger,
#app .el-button--text.danger {
  color: var(--admin-red) !important;
}

#app .el-input__inner,
#app .el-textarea__inner,
#app .el-select .el-input__inner {
  border-radius: var(--admin-radius);
  border-color: var(--admin-border-strong);
  color: var(--admin-text);
  background: rgba(255, 255, 255, 0.9);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

#app .el-input__inner:hover,
#app .el-textarea__inner:hover {
  border-color: rgba(22, 119, 255, 0.35);
}

#app .el-input__inner:focus,
#app .el-textarea__inner:focus {
  border-color: var(--admin-primary);
  box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.12);
}

#app .el-table {
  overflow: hidden;
  border-radius: var(--admin-radius);
  border-color: var(--admin-border) !important;
  color: #273244;
  background: var(--admin-surface-strong);
  box-shadow: 0 1px 0 rgba(23, 31, 46, 0.04);
}

#app .el-table::before,
#app .el-table--group::after,
#app .el-table--border::after {
  background-color: var(--admin-border);
}

#app .el-table th.el-table__cell {
  color: #3d4b61;
  font-weight: 800;
  background: #f0f4f9 !important;
}

#app .el-table td.el-table__cell,
#app .el-table th.el-table__cell.is-leaf {
  border-bottom-color: rgba(29, 43, 64, 0.08);
}

#app .el-table--border .el-table__cell {
  border-right-color: rgba(29, 43, 64, 0.08);
}

#app .el-table__body tr:hover > td.el-table__cell {
  background: #f8fbff !important;
}

#app .el-table .cell {
  line-height: 1.55;
}

#app .el-tabs__nav-wrap::after {
  height: 1px;
  background: var(--admin-border);
}

#app .el-tabs__item {
  color: #607089;
  font-weight: 700;
}

#app .el-tabs__item.is-active {
  color: var(--admin-primary);
}

#app .el-tabs__active-bar {
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--admin-primary), var(--admin-cyan));
}

#app .el-card {
  border-color: var(--admin-border);
  border-radius: var(--admin-radius);
  background: rgba(255, 255, 255, 0.86);
  box-shadow: var(--admin-shadow-soft);
}

#app .el-card__header {
  border-bottom-color: var(--admin-border);
}

#app .el-dialog {
  overflow: hidden;
  border-radius: var(--admin-radius);
  box-shadow: 0 24px 70px rgba(23, 31, 46, 0.22);
}

#app .el-dialog__header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--admin-border);
  background: linear-gradient(180deg, #ffffff, #f8fafc);
}

#app .el-dialog__title {
  color: var(--admin-text);
  font-weight: 800;
}

#app .el-dialog__body {
  color: #2d3748;
}

#app .el-alert {
  border-radius: var(--admin-radius);
  border: 1px solid rgba(22, 119, 255, 0.12);
}

#app .el-tag {
  border-radius: 6px;
  font-weight: 700;
}

#app .pager {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

#app .page-text {
  color: var(--admin-muted);
  font-weight: 700;
}

#app .detail-pre,
#app .log-json,
#app pre {
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius);
  background: #f8fafc !important;
}

#app .avatar,
#app .avatar img,
#app .user-avatar-link,
#app .top-rank-avatar {
  box-shadow: 0 6px 18px rgba(23, 31, 46, 0.12);
}

#app .avatar-uploader .el-upload {
  border-color: var(--admin-border-strong) !important;
  border-radius: var(--admin-radius) !important;
  background: rgba(248, 250, 252, 0.72);
}

#app .avatar-uploader .el-upload:hover {
  border-color: var(--admin-primary) !important;
  box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.1);
}

#app .metric-row {
  margin-bottom: 22px;
}

#app .metric-card,
#app .expansion-metric {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--admin-radius) !important;
  box-shadow: 0 16px 32px rgba(23, 31, 46, 0.14);
}

#app .metric-card::after,
#app .expansion-metric::after {
  content: "";
  position: absolute;
  right: -48px;
  bottom: -64px;
  width: 150px;
  height: 150px;
  transform: rotate(24deg);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.22), transparent);
}

#app .metric-icon {
  background: rgba(255, 255, 255, 0.2) !important;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);
}

#app .metric-value,
#app .expansion-metric-value {
  letter-spacing: 0;
}

#app .metric-card.cyan {
  background: linear-gradient(135deg, #008f7d, #17c3a5) !important;
}

#app .metric-card.blue {
  background: linear-gradient(135deg, #1d64d8, #4dabf7) !important;
}

#app .metric-card.purple {
  background: linear-gradient(135deg, #7048e8, #9775fa) !important;
}

#app .metric-card.orange {
  background: linear-gradient(135deg, #d9480f, #f59f00) !important;
}

#app .metric-card.green {
  background: linear-gradient(135deg, #2b8a3e, #69db7c) !important;
}

#app .metric-card.red {
  background: linear-gradient(135deg, #c92a2a, #ff6b6b) !important;
}

#app .app-preview-frame,
#app .astrbot-frame,
#app .danmakus-frame {
  overflow: hidden;
  border: 1px solid var(--admin-border) !important;
  border-radius: var(--admin-radius);
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(23, 31, 46, 0.04);
}

#app .switch-line,
#app .status-line,
#app .info-row,
#app .section {
  border-color: var(--admin-border) !important;
}

#app .el-loading-mask {
  border-radius: var(--admin-radius);
  background: rgba(248, 250, 252, 0.72);
  backdrop-filter: blur(6px);
}

@media (max-width: 1280px) {
  body {
    min-width: 1024px;
  }

  #app .app-admin-page,
  #app .app-preview-page,
  #app .runtime-log-page,
  #app .game-admin-page {
    padding: 18px !important;
  }

  #app .home-main > div > div[style*="box-shadow"] {
    width: calc(100% - 36px) !important;
    height: calc(100% - 36px) !important;
    margin: 18px !important;
  }
}
</style>
